import Layout from '@/components/layout/index.vue'
export default {
  path: 'deliverysynergysupplier',
  name: 'Deliverysynergysupplier',
  meta: {},
  component: Layout,
  redirect: { name: 'Deliverysynergysupplier.deliveryreply' },
  children: [
    {
      path: 'deliveryreply',
      name: 'Deliverysynergysupplier.deliveryreply',
      meta: {},
      component: () => import(/* webpackChunkName: "deliverysynergy" */ '@/views/supplier/deliverysynergysupplier/deliveryreply/index.vue')
    },
    {
      path: 'lookreply',
      name: 'Deliverysynergysupplier.lookreply',
      meta: {},
      component: () => import(/* webpackChunkName: "deliverysynergy" */ '@/views/supplier/deliverysynergysupplier/lookreply/index.vue')
    },
    {
      path: 'deliveryschedulesupplier',
      name: 'Deliverysynergysupplier.deliveryschedulesupplier',
      meta: {},
      component: () => import(/* webpackChunkName: "deliverysynergy" */ '@/views/supplier/deliverysynergysupplier/deliveryschedulesupplier/index')
    },
    {
      path: 'asn',
      name: 'Deliverysynergysupplier.asn',
      meta: {},
      component: () => import(/* webpackChunkName: "deliverysynergy" */ '@/views/supplier/deliverysynergysupplier/asn/index.ts')
    },
    {
      path: 'asn/add',
      name: 'Deliverysynergysupplier.addAsn',
      meta: { title: 'common.add', dep: 'Deliverysynergysupplier.asn' },
      component: () => import(/* webpackChunkName: "deliverysynergy" */ '@/views/supplier/deliverysynergysupplier/addAsn/index.ts')
    },
    {
      path: 'shippingschedule',
      name: 'Deliverysynergysupplier.shippingschedule',
      meta: { },
      component: () => import(/* webpackChunkName: "deliverysynergy" */ '@/views/supplier/deliverysynergysupplier/shippingschedule/index.ts')
    }
  ]
}
